import React from "react";
import printIcon from "../../../../../assets/SVGs/fluent_print-32-filled.svg";
import dotsIcon from "../../../../../assets/SVGs/dotsIcon.svg";
export const FormPrintouts = () => {
  const formPrintouts = [
    { name: "Supply Expiration Tracking", link: "" },
    { name: "Emergency Plan Printouts", link: "" },
    { name: "Inventory Report", link: "" },
    { name: "Document Checklist", link: "" },
    { name: "Insurance Summary Report", link: "" },
    { name: "Emergency Contact Card", link: "" },
  ];
  return (
    <div className="print-out-card-main">
      {formPrintouts &&
        formPrintouts.map((item, index) => (
          <div key={index} className="print-out-card">
            <div
              className="cardHeadingDisability"
              style={{ borderLeft: "3px solid #2a3da3", paddingLeft: "8px" }}
            >
              <div
                className="print-out-card-heading"
                style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
              >
                {" "}
                {item.name}{" "}
                <span style={{ color: "#E13C25" }}>Coming Soon</span>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <img src={printIcon} alt="print"></img>
                <img src={dotsIcon} alt="bell"></img>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};
